export default {
  path: '/processes',
  name: 'Process',
  component: () => import('../components/process/Layout'),
  redirect: { name: 'ProcessList' },
  meta: {
    breadcrumb: 'process.documentations',
  },
  children: [

    {
      name: 'ProcessList',
      path: '',
      component: () => import('../views/process/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProcessListType',
      path: 'type',
      component: () => import('../views/process/ListType'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProcessListByType',
      path: 'type/:id',
      component: () => import('../views/process/ListByType'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProcessCreate',
      path: 'new',
      component: () => import('../views/process/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProcessUpdate',
      path: ':id/edit',
      component: () => import('../views/process/Update'),
      meta: {
        breadcrumb: 'process.documentation',
      },
    },
    {
      name: 'ProcessShow',
      path: ':id',
      component: () => import('../views/process/Show'),
      meta: {
        breadcrumb: 'process.documentation',
      },
    },
    {
      name: 'Step',
      path: ':parent',
      component: () => import('../components/step/Layout'),
      meta: {
        breadcrumb: 'process.steps',
      },
      children: [
        {
          name: 'StepCreate',
          path: 'new',
          component: () => import('../views/step/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
        {
          name: 'StepUpdate',
          path: ':id/edit',
          component: () => import('../views/step/Update'),
          meta: {
            breadcrumb: 'process.step',
          },
        },
        {
          name: 'StepShow',
          path: ':id',
          component: () => import('../views/step/Show'),
          meta: {
            breadcrumb: 'process.step',
          },
        },
        {
          name: 'StepFieldCreate',
          path: ':stepid/newfield',
          component: () => import('../views/step/CreateField'),
          meta: {
            breadcrumb: 'process.step',
          },
        }
      ]

    },
  ]
};
